import { forwardRef, Icon, IconProps } from '@chakra-ui/react';
import { useIconId } from '../utils';

const BitbucketBlue = forwardRef<IconProps, 'svg'>((props, ref) => {
  const iconPrefix = useIconId();
  return (
    <Icon ref={ref} viewBox="0 0 24 24" {...props}>
      <path
        d="M2.64203 3C2.24241 3 1.94269 3.36633 2.00929 3.73265L4.70679 20.2506C4.77339 20.6836 5.13972 20.9833 5.57265 20.9833H18.6272C18.9269 20.9833 19.1934 20.7502 19.2599 20.4504L21.9907 3.76596C22.0574 3.36633 21.7576 3.03331 21.358 3.03331L2.64203 3ZM14.0981 14.9223H9.93526L8.83626 9.02776H15.1304L14.0981 14.9223Z"
        fill="#2684FF"
      />
      <path
        d="M21.0915 9.02776H15.0971L14.0981 14.9223H9.93526L5.03976 20.7502C5.03976 20.7502 5.27287 20.95 5.6059 20.95H18.6604C18.9602 20.95 19.2266 20.7169 19.2932 20.4171L21.0915 9.02776Z"
        fill={`url(#${iconPrefix}__a)`}
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${iconPrefix}__a`}
          x1={22.4938}
          x2={12.56}
          y1={10.6887}
          y2={18.443}
        >
          <stop offset={0.176} stopColor="#0052CC" />
          <stop offset={1} stopColor="#2684FF" />
        </linearGradient>
      </defs>
    </Icon>
  );
});

export default BitbucketBlue;
